import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import template from './toolChangeReport.tpl.html';
import {Colors, States} from "../../shared/config/constant.module";
import {ICommonQueryingReport} from "./commonQueryingReport";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import {StateParams} from "../../common";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import {apsEnums} from "../../shared/dto/aps.enums";

let requires = [UIUtilityServiceName, LoaderServiceName, ReportServiceName, NavigationServiceName];
  
interface ToolChangeReportController extends ICommonQueryingReport {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  uiStartDate: Date;
  uiEndDate: Date;
  startDate: Date;
  endDate: Date;
  selectedToolName: string;
  selectedReason: EnumOption;
  form: any;

  reasons: EnumOption[];

  reportShopName: string;
  reportStartDate: Date;
  reportEndDate: Date;
  reportReason: EnumOption;
  reportTimeZoneId: string;

  summaryResults: apsViewModels.ToolChangeReportItemSummary[];
  summaryResultsPretty: any[];
  detailResults: apsViewModels.DropReportDetails;
  searchPerformed: boolean;

  generateReport(): void;
  generateDetailReport(toolName: string): void;
  formatTime(time: Date): string;
  getCavityHistoryColor(): string;

  selectTool(toolName: string);
  scopeWorkaround: any;
}

interface ToolChangeReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
  reason: string;
  tool: string;
  autoRun: boolean;
}

class ToolChangeReportCtrl implements ToolChangeReportController {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  uiStartDate: Date;
  uiEndDate: Date;
  startDate: Date;
  endDate: Date;
  selectedToolName: string;
  selectedReason: EnumOption;
  form: any;

  reasons: EnumOption[];

  reportShopName: string;
  reportStartDate: Date;
  reportEndDate: Date;
  reportReason: EnumOption;
  reportTimeZoneId: string;

  summaryResults: apsViewModels.ToolChangeReportItemSummary[];
  summaryResultsPretty: any[];
  detailResults: apsViewModels.DropReportDetails;
  searchPerformed: boolean;

  scopeWorkaround: any;

  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  uiUtilityService: UIUtilityService;

  requirePlantSelection: boolean;
  requireShopSelection: boolean;
  private $stateParams: ToolChangeReportParams;
  private $q: angular.IQService;

  constructor(
    $state: angular.ui.IStateService,
    $q: angular.IQService,
    $stateParams: ToolChangeReportParams,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    uiUtilityService: UIUtilityService) {
    var vm = this;

    this.$q = $q;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.uiUtilityService = uiUtilityService;
    this.reportService = reportService;

    this.requirePlantSelection = true;
    this.requireShopSelection = true;

    var now = moment().add(1, 'hours').startOf('hour');
    this.uiEndDate = now.toDate();
    this.uiStartDate = now.clone().subtract(1, 'days').toDate();

    this.reasons = uiUtilityService.getListOptionsFromEnum(apsEnums.ToolChangeReason);

    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;
      this.updatePlant();
      this.selectedShop = navModel.selectedShop;

      return this.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);

    this.scopeWorkaround = {
      summaryBarClick: function (dimpleEvent) {
        if (dimpleEvent && dimpleEvent.xValue) {
          vm.selectTool(dimpleEvent.xValue);
        }
      },
      formatTime: function (date: Date) {
        return vm.formatTime(date);
      }
    };
  }

  loadState(params: ToolChangeReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        var shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }

    if (params.startDate) {
      var startDate = moment(params.startDate);
      if (startDate.isValid()) {
        this.startDate = startDate.toDate();
      }
    }

    if (params.endDate) {
      var endDate = moment(params.endDate);
      if (endDate.isValid()) {
        this.endDate = endDate.toDate();
      }
    }

    if (params.reason !== undefined) {
      var reason = _.find(this.reasons, { value: +params.reason }); // !!!
      if (reason) {
        this.selectedReason = reason;
      }
    }

    if (params.autoRun) {
      return this.runReport().then(() => {
        if (this.summaryResults && this.summaryResults.length && params.tool) {
          return this.runDetailReport(params.tool);
        }
      });
    }

    return this.$q.when();
  }

  saveState(tool: string): void {
    var selectedReasonId = this.selectedReason ? this.selectedReason.value : null;
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }

    var params: ToolChangeReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      reason: selectedReasonId,
      tool: tool,
      autoRun: true
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport(): angular.IPromise<any> {
    if (this.form.$invalid) {
      return;
    }

    this.saveState(null);

    var promise = this.runReport();
    this.loaderService.loadingPromise(promise);
    return promise;
  }

  private runReport(): angular.IPromise<any> {
    var selectedReasonId = this.selectedReason ? this.selectedReason.value : null;

    return this.reportService.getToolChangeReport(this.selectedShop.id, selectedReasonId,
      this.startDate, this.endDate)
      .then(summaryResults => {
        this.summaryResults = summaryResults;
        this.summaryResultsPretty = _.map(summaryResults, (result) => {
          return {
            'Tool Name': result.toolName,
            'Count': result.count
          };
        });

        this.searchPerformed = true;

        this.reportStartDate = this.startDate;
        this.reportEndDate = this.endDate;
        this.reportShopName = this.selectedShop.name;
        this.reportReason = this.selectedReason;
        this.reportTimeZoneId = this.selectedPlant.timeZoneId;

        this.detailResults = null;
      });
  }

  generateDetailReport(toolName: string): void {
    if (this.form.$invalid) {
      return;
    }

    this.saveState(toolName);

    this.loaderService.loadingPromise(this.runDetailReport(toolName));
  }

  private runDetailReport(toolName: string): angular.IPromise<any> {
    var reportReasonId = this.reportReason ? this.reportReason.value : null;
    return this.reportService.getToolChangeReportDetails(
      this.selectedShop.id,
      reportReasonId,
      toolName,
      this.reportStartDate,
      this.reportEndDate)
      .then(detailResults => {
        this.detailResults = detailResults;
        this.selectedToolName = toolName;
      });
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.reportTimeZoneId);
  }

  selectTool(toolName: string) {
    this.generateDetailReport(toolName);
  }

  getCavityHistoryColor() {
    return Colors.TOOL_CHANGE;
  }

  updatePlant(): void {
    this.selectedShop = null;
  }
}

export default angular.module('aps.controller.toolChangeReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.TOOL_CHANGE_REPORT,
      url: '/admin/reports/toolChange?startDate&endDate&reason&tool&autoRun&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        reason: {dynamic: true},
        tool: {dynamic: true},
        autoRun: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'ToolChangeReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Tool Change Report'
      }
    });
  })
  .controller('ToolChangeReportCtrl', ToolChangeReportCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/reports/toolChangeReport.controller.ts